import queryFn from "ApiLayer/Reports/Recommendations/queryAnnualCarbonEmissionsCard";
import { useAccessToken } from "hooks/useAccessToken";
import { useQuery } from "react-query";
import { QUERY_STALE_TIME } from "utils/constants";

export const useAnnualCarbonEmissionsCard = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["recommendationsAnnualCarbonEmissionsCard", filtersetUid],
        queryFn: async () => queryFn(accessToken, { reportFiltersetUid: filtersetUid }),
        staleTime: QUERY_STALE_TIME,
    });
};
